import { RequestConfig } from "@umijs/max";
import { message } from "antd";
import { AxiosError } from "axios";
import { useAuthService } from "./useAuthService";

const { logout } = useAuthService();

const request: RequestConfig = {
  // timeout: 30000,
  // other axios options you want
  errorConfig: {
    async errorHandler(error, { }) {
      const { config, response, code } = error as AxiosError<{
        error: { message: string };
      }>;
      console.log(error, 'error');
      const messageText = response?.data?.error?.message;
      if (messageText) {
        message.error(messageText);
      }
      if (response?.status === 401) {
        // 处理 401 错误，例如跳转到登录页
        await logout();
        window.location.href = '/login';
      }
      return Promise.reject(error);
    },
    errorThrower() { },
  },
  requestInterceptors: [
    (url, options) => {
      const { headers = {} as any } = options;
      headers['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');
      // do something
      return { url: BASE_URL + url, options };
    },
  ],
  responseInterceptors: [
    (response) => {
      // 不再需要异步处理读取返回体内容，可直接在data中读出，部分字段可在 config 中找到
      const { data = {} as any, config } = response;
      if (config.responseType === 'blob') {
        return response;
      }

      // response的结构不统一，不一定有isSuccess字段
      if (data?.hasOwnProperty?.('isSuccess') && data?.isSuccess === false) {
        // message.error(data.message || '请求失败');
        return Promise.reject(response);
      }

      // do something
      return response;
    },
  ],
};

export default request;